<template>
    <div>
        <ul class="upgrade-header">
            <li class="upgrade-header-col">
                <UpgradeRowBadge upgrade="Byte" />
            </li>
            <li class="upgrade-header-col">
                <UpgradeRowBadge upgrade="Kilo" />
            </li>
            <li class="upgrade-header-col">
                <UpgradeRowBadge upgrade="Mega" />
            </li>
            <li class="upgrade-header-col">
                <UpgradeRowBadge upgrade="Giga" />
            </li>
        </ul>
        <UpgradeRow v-for="p in allParticipants" :key="p.key" :participant="p"
            @upgrade-changed="onUpgradeChanged" />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import _ from 'lodash';
import UpgradeRow from "@/components/classroom/sidePanel/upgrades/UpgradeRow.vue";
import UpgradeRowBadge from "@/components/classroom/sidePanel/upgrades/UpgradeRowBadge.vue";

const emit = defineEmits(['upgradeChanged']);

const props = defineProps({
    participants: Object,
    expectedParticipants: Object
});

const allParticipants = computed(() => {
    const active = props.participants || [];
    const expected = props.expectedParticipants || [];

    // Clone deep to avoid mutating props directly
    const mergedList = _.cloneDeep(active);

    // Merge expected data or append missing expected participants
    for (const ep of expected) {
        const found = mergedList.find(
            p => p.userData?.studentUuid === ep.userData?.studentUuid
        );

        if (found) {
            found.userData = _.merge({}, found.userData, ep.userData);
        } else {
            mergedList.push(ep);
        }
    }

    // Always sort the final combined array by user_name (case-insensitive)
    return _.sortBy(mergedList, (p) => p.user_name?.toLowerCase() ?? '');
});

function onUpgradeChanged(data) {
    emit('upgradeChanged', data);
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.upgrade-header {
    display: flex;
    list-style-type: none;
    padding: 0;
    margin: 0.5vh 0;
    justify-content: right;

    li {
        input {
            margin: 0 5px;
        }
    }

    &-col {
        width: 30px;
        text-align: center;
        cursor: default;
    }
}
</style>